const caseParams = (accountId, postSaleCase) => ({
  accountId,
  postSaleCaseId: postSaleCase.id,
});

export const postSaleAgendaLocation = ({
  accountId,
  postSaleCase,
  action,
  query = {},
}) => {
  if (action?.kind === 'status') {
    return {
      name: 'operacao_imobiliaria_pos_venda_status',
      params: caseParams(accountId, postSaleCase),
      query: { ...query, agenda_action: action.code || undefined },
    };
  }

  if (action?.kind === 'nucleo') {
    return {
      name: 'operacao_imobiliaria_pos_venda_pedidos_servico',
      params: {
        accountId,
        salesTransactionId: postSaleCase.property_transaction_id,
      },
      query,
    };
  }

  return {
    name: 'operacao_imobiliaria_pos_venda_detalhes',
    params: caseParams(accountId, postSaleCase),
    query,
  };
};
